import { styled, useTheme } from '@mui/material/styles';
import { Box, Stepper, Step, StepLabel, StepConnector, stepConnectorClasses, useMediaQuery } from "@mui/material";
import { 
  Plane, 
  FileText, 
  GraduationCap, 
  Users, 
  ClipboardList,
  CheckCircle, 
  Briefcase
} from "lucide-react";

// Custom connector styled to be between step icons
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16, // Position between the icons
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#1976d2',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#1976d2',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderTopWidth: 2,
    borderColor: '#e0e0e0',
    borderRadius: 1,
  },
}));

// Custom Step Icon Component
const CustomStepIcon = ({ active, completed, icon: Icon }) => {
  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: completed ? '#1976d2' : active ? '#1976d2' : 'transparent',
        border: completed ? '2px solid #1976d2' : active ? '2px solid #1976d2' : '2px solid #e0e0e0',
        color: completed ? 'white' : active ? 'white' : '#666',
        transition: 'all 0.3s ease',
      }}
    >
      <Icon size={16} />
    </Box>
  );
};
const CustomStepper = ({ activeStep, steps }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const stepIcons = [
    { icon: Briefcase, label: "Job Overview", shortLabel: "Overview" },
    { icon: FileText, label: "Description & Requirements", shortLabel: "Description" },
    { icon: GraduationCap, label: "Qualifications & Experience", shortLabel: "Qualifications" },
    { icon: Users, label: "Screening Questions (Interview)", shortLabel: "Screening" },
    { icon: ClipboardList, label: "Application Details", shortLabel: "Application" },
    { icon: CheckCircle, label: "Review & Submit", shortLabel: "Review" }
  ];

  // Use short labels for mobile, full labels for desktop
  const displaySteps = isMobile 
    ? stepIcons.map(icon => icon.shortLabel)
    : steps;

  return (
    <Box sx={{ 
      width: '100%', 
      mb: 4,
      overflow: isMobile ? 'auto' : 'auto'
    }}>
      <Box sx={{ 
        minWidth: isMobile ? '400px' : 'auto',
        pb: isMobile ? 1 : 0
      }}>
        <Stepper 
          activeStep={activeStep} 
          alternativeLabel
          connector={<CustomConnector />}
          sx={{
            '& .MuiStep-root': {
              padding: isSmallMobile ? '0 2px' : '0 4px',
            },
            '& .MuiStepLabel-root': {
              paddingX: isSmallMobile ? 0.5 : 1,
            },
            '& .MuiStepLabel-label': {
              marginTop: 0.5,
              fontWeight: 600,
              fontSize: isSmallMobile ? '0.65rem' : '0.75rem',
              lineHeight: 1.1,
              textAlign: 'center',
              whiteSpace: 'nowrap',
              '&.Mui-active': {
                fontWeight: 700,
                color: '#1976d2'
              },
              '&.Mui-completed': {
                color: '#1976d2'
              }
            },
          }}
        >
          {displaySteps.map((label, index) => {
            const stepIcon = stepIcons[index];
            const IconComponent = stepIcon?.icon || CheckCircle;
            
            return (
              <Step key={label}>
                <StepLabel
                slots={{
                  stepIcon: (props) => (
                    <CustomStepIcon {...props} icon={IconComponent} />
                  )
                }}
                  // StepIconComponent={(props) => (
                  //   <CustomStepIcon {...props} icon={IconComponent} />
                  // )}
                >
                  {label}
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>
    </Box>
  );
};

export default CustomStepper;